<template lang="pug">
div#site
    navbar(:color="navbarColor")
    transition(
        name="fade-page" mode="out-in" 
        @before-leave="colorize(true, 'begin')" @before-enter="colorize(true, 'middle')" @after-enter="colorize(false, 'end')"
    )
        router-view.wrap(@init="changePage" @end-loading="endLoading")
    footerbar(v-show="!!footerColor" :color="footerColor")
    loader(v-show="showLoader" :color="navbarColor")
</template>

<script>
import Navbar from './components/layouts/Navbar.vue'
import Footer from './components/layouts/Footer.vue'
import Loader from './components/layouts/Loader.vue'

export default {
    name: 'App',
    metaInfo() {
        return {
            title: 'Page title',
            titleTemplate: '%s | Sota.',
            meta: [
                { vmid: 'ogimage', property: "og:image", content: this.$store.state.socialImage },
                { property: "og:locale", content: this.$i18n.locale },
                { property: "og:locale:alternate", content: (this.$i18n.locale == "en-US" ? "ru-RU" : "en-US") },
                { property: "og:site_name", content: "Sota." },
                { property: "og:see_also", content: this.$store.state.url },
                { name: "twitter:site", content: "Sota." },
                { name: "twitter:domain", content: this.$store.state.url },
                { vmid: 'twitterimage', name: "twitter:image:src", content: this.$store.state.socialImage }
            ]
        }
    },
    data() {
        return {
            transition: {
                mode: "out-in",
                colorize: false
            },
            navbarColor: "white",
            footerColor: null,
            showLoader: false
        }
    },
    components: {
        'navbar': Navbar,
        'footerbar': Footer,
        'loader': Loader
    },
    created() {
        this.$http.get("pages/contacts").then(response => {
            this.$store.commit("setContacts", response.body)
        })
        this.$http.get("pages/main").then(response => {
            this.$store.commit("setSocialImage", response.body.socialImage)
        })
    },
    methods: {
        changePage(navbarColor, footerColor) {
            this.navbarColor = navbarColor;
            this.footerColor = footerColor;
            this.showLoader = true;
        },
        endLoading() {
            this.showLoader = false;
        },
        colorize(colorize, step) {
            document.body.style.background = this.transition.colorize && colorize ? "black" : "white";
            if (step == "end") {
                var routesName = ['Main', 'Projects', 'Project']
                document.body.style.background = routesName.includes(this.$route.name) ? "black" : "white";
            }
        }
    },
    watch: {
        '$route'(to, from) {
            var routesName = ['Main', 'Projects', 'Project']
            this.transition.colorize = (routesName.includes(to.name) && routesName.includes(from.name));
        }
    }
}
</script>

<style lang="scss">
@import "~styles/base.scss";
.wrap {
    position: relative;
    margin-top: -70px;
    padding-top: 70px;
}
</style>




// WEBPACK FOOTER //
// App.vue?2c07ac17